import { Link } from "react-router-dom";
import { Phone, Car } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS, fileUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const Header = () => {
  const { settings } = useSettings() || {};
  const logo = settings?.logo_image ? fileUrl(settings.logo_image) : null;
  return (
    <header
      className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="header-logo-link">
          {logo ? (
            <img src={logo} alt="Erskine Auto logo" className="h-9 w-auto max-w-[160px] object-contain" data-testid="header-logo-image" />
          ) : (
            <>
              <span className="w-9 h-9 rounded-lg bg-red-600 flex items-center justify-center text-white group-hover:scale-105 transition-transform">
                <Car size={20} />
              </span>
              <span className="font-display font-extrabold text-lg tracking-tight text-slate-900">
                Erskine Auto
              </span>
            </>
          )}
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/inventory"
            className="text-sm font-semibold text-slate-700 hover:text-red-600 transition-colors"
            data-testid="header-inventory-link"
          >
            Inventory
          </Link>
          <span className="text-xs text-slate-400 hidden lg:inline">{ADDRESS}</span>
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors active:scale-95"
            data-testid="header-call-button"
          >
            <Phone size={16} /> {PHONE_DISPLAY}
          </a>
        </div>

        <a
          href={`tel:${PHONE_TEL}`}
          className="md:hidden inline-flex items-center gap-1 bg-red-600 text-white text-sm font-semibold px-3 py-2 rounded-full active:scale-95"
          data-testid="header-call-button-mobile"
        >
          <Phone size={16} /> Call
        </a>
      </div>
    </header>
  );
};
